import React, { Component, useRef, RefObject } from 'react';
import routes from '../../routes.json';
import { Link } from 'react-router-dom';

interface IMainMenuState {
  menuOpen: boolean;
  searchOpen: boolean;
  searchInput: string;
}

const defState = {
  menuOpen: false,
  searchOpen: false,
  searchInput: '',
}

class MainMenu extends Component {
  public state: IMainMenuState = defState;
  public searchInputRef: RefObject<HTMLInputElement> = React.createRef();

  public toggleMenu = () => {
    const origState = this.state.menuOpen;
    this.setState({ menuOpen: !origState });
  }

  public toggleSearch = () => {
    const origState = this.state.searchOpen;
    this.setState({ searchOpen: !origState });
  }

  public setInputValue = (e: any) => {
    const value = e.target.value;
    this.setState({searchInput: value})
  }

  public clearInput = () => {
    setTimeout(() => {
      this.setState({searchInput: '', searchOpen: false})
    }, 100);
  }

  render() {
    const { menuOpen, searchOpen, searchInput } = this.state;
    const resultsOpen = searchInput.length > 0 ? true : false;

    return (
      <div className="header-wrapper">
        <div className="header-container">
          <Link to={routes.HOME} className="logo text-tezos">
            Aromarea
          </Link>
          <div className="wave left" />
          <nav className={`mainMenu ${menuOpen ? 'visible' : ''}`}>
            <Link className="mainMenu-link" onClick={this.toggleMenu} to={routes.ABOUT}>o mně</Link>
            <Link className="mainMenu-link" onClick={this.toggleMenu} to={routes.AROMATHERAPY}>aromaterapie</Link>
            <Link className="mainMenu-link" onClick={this.toggleMenu} to={routes.MASSAGE}>masáže</Link>
            <Link className="mainMenu-link" onClick={this.toggleMenu} to={routes.WELLNESS}>wellness</Link>
            <Link className="mainMenu-link" onClick={this.toggleMenu} to={routes.CONTACT}>kontakt</Link>
          </nav>
          <div className="wave right" />

          {/* SEARCH INPUT */}
          {/* <div className={`search-wrapper ${searchOpen ? 'active': ''}`}>
            <button
              type="button"
              className="search-toggler"
              onClick={this.toggleSearch}
            />
            <input 
              type="input"
              name="search"
              placeholder="vyhledávání"
              ref={this.searchInputRef}
              value={searchInput}
              onChange={this.setInputValue}
              onBlur={this.clearInput}
            />
            {resultsOpen && 
              <div className="search-results">
                <Link to="/result-url" className="link">
                  Search result line link
                </Link>
                <Link to="/result-url" className="link">
                  Search result line link
                </Link>
                <Link to="/result-url" className="link">
                  Search result line link
                </Link>
                <Link to="/result-url" className="link">
                  Search result line link link link link
                </Link>
                <Link to="/result-url" className="link">
                  Search result line link
                </Link>
              </div>
            }
          </div> */}
          <button type="button" className="toggle-menu" onClick={this.toggleMenu}>
            <div className={`hamburger-icon ${menuOpen ? 'open': ''}`}>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
            </div>
          </button>
        </div>
      </div>
    );
  }
}

export default MainMenu;